import config from 'config'
import { connect } from 'react-redux'
import bowser from 'bowser'
import { Component } from 'macguffin/components'
import { setReplayUrl } from '../../../redux/actions'

/**
 * This is the replay DOM component.
 * It will display the button which will allow the user
 * to look at the previous round history.
 */
@connect(state => ({
  session: state.session
}), { setReplayUrl })
export default class Replay extends Component {
  /**
   * Opens up the replay in a new window, using the session data.
   */
  openReplay = () => {
    const { session } = this.props
    const id = config.GAME_CONFIG.GAME_ID
    const frameUrl = `${session.gameReplayServiceURL}?gameid=${id}&replaytoken=${
      session.replayToken}&lang=${session.locale}`

    const isReallySafari = navigator && /safari/i.test(navigator.userAgent)

    if (bowser.ios && (!bowser.safari || (bowser.safari && !isReallySafari))) {
      this.props.setReplayUrl(frameUrl)
    } else {
      window.open(frameUrl)
    }
  }

  /**
   * Renders the replay button DOM element.
   */
  render() {
    return (
      <div className="replay">
        <div className="replay-header">
          { this.t('settings.replay') }
        </div>
        <button className="replay-button fa fa-history" onClick={this.openReplay} />
      </div>
    )
  }
}
